import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-002a341c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "· 已开启众筹 ·", -1));
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "render-line-clamp",
  src: "https://p6.moimg.net/md/icon/project_title_icon@2x.png"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createBlock(_component_van_overlay, {
    show: $props.show,
    onClick: $options.close
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "inner",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [_hoisted_1, _createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter($props.proInfo.logo, 520)}`
    }, null, 8, _hoisted_2), _createElementVNode("h2", null, [_hoisted_3, _createTextVNode(" " + _toDisplayString($props.proInfo.title), 1)]), _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.topay && $options.topay(...args), ["stop"])),
      class: "btn"
    }, "立即购买支持"), _createElementVNode("p", {
      class: "tips",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.close && $options.close(...args), ["stop"]))
    }, "继续浏览创意")])]),
    _: 1
  }, 8, ["show", "onClick"]);
}